import * as React from 'react';
import { TApiProcessEntity } from '../../../types/Process';
import { ChangeEvent } from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ProcessList from '../../processes/ProcessList';

interface IProcessProps {
  processes: Array<TApiProcessEntity>;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
  })
);

const Process: React.FC<IProcessProps> = ({
  processes,
  expanded,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange('panel11')}
      key={'panel11'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`expandedProcessnbh-content`}
        id={`expandedProcessbh-header`}
      >
        <Typography className={classes.heading}>{t("chemicals.processes")}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        <div className={classes.root}>
          <ProcessList processes={processes} />
        </div>
      </AccordionDetails>
    </Accordion>
  );
}

export default Process;